import { render, staticRenderFns } from "./traduction.vue?vue&type=template&id=0ab811e1&scoped=true"
import script from "./traduction.vue?vue&type=script&lang=js"
export * from "./traduction.vue?vue&type=script&lang=js"
import style0 from "./traduction.vue?vue&type=style&index=0&id=0ab811e1&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab811e1",
  null
  
)

export default component.exports